!function (i, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (i = i || self, i.RSA = t());
}(this, function () {
  "use strict";

  function i(i) {
    x = i, R = new Array(x);

    for (var n = 0; n < R.length; n++) {
      R[n] = 0;
    }

    K = new t(), (j = new t()).digits[0] = 1;
  }

  function t(i) {
    this.digits = "boolean" == typeof i && 1 == i ? null : R.slice(0), this.isNeg = !1;
  }

  function n(i) {
    var n = new t(!0);
    return n.digits = i.digits.slice(0), n.isNeg = i.isNeg, n;
  }

  function s(i) {
    for (var t = "", n = i.length - 1; n > -1; --n) {
      t += i.charAt(n);
    }

    return t;
  }

  function e(i, n) {
    var e = new t();
    e.digits[0] = n;

    for (var r = D(i, e), g = O[r[1].digits[0]]; 1 == y(r[0], K);) {
      r = D(r[0], e), digit = r[1].digits[0], g += O[r[1].digits[0]];
    }

    return (i.isNeg ? "-" : "") + s(g);
  }

  function r(i) {
    for (var t = "", n = 0; n < 4; ++n) {
      t += Q[15 & i], i >>>= 4;
    }

    return s(t);
  }

  function g(i) {
    for (var t = "", n = (l(i), l(i)); n > -1; --n) {
      t += r(i.digits[n]);
    }

    return t;
  }

  function d(i) {
    return i >= 48 && i <= 57 ? i - 48 : i >= 65 && i <= 90 ? 10 + i - 65 : i >= 97 && i <= 122 ? 10 + i - 97 : 0;
  }

  function o(i) {
    for (var t = 0, n = Math.min(i.length, 4), s = 0; s < n; ++s) {
      t <<= 4, t |= d(i.charCodeAt(s));
    }

    return t;
  }

  function u(i) {
    for (var n = new t(), s = i.length, e = 0; s > 0; s -= 4, ++e) {
      n.digits[e] = o(i.substr(Math.max(s - 4, 0), Math.min(s, 4)));
    }

    return n;
  }

  function a(i) {
    for (var t = "", n = l(i); n > -1; --n) {
      t += f(i.digits[n]);
    }

    return t;
  }

  function f(i) {
    var t = String.fromCharCode(255 & i);
    return i >>>= 8, String.fromCharCode(255 & i) + t;
  }

  function h(i, n) {
    var s;
    if (i.isNeg != n.isNeg) n.isNeg = !n.isNeg, s = c(i, n), n.isNeg = !n.isNeg;else {
      s = new t();

      for (var e, r = 0, g = 0; g < i.digits.length; ++g) {
        e = i.digits[g] + n.digits[g] + r, s.digits[g] = 65535 & e, r = Number(e >= H);
      }

      s.isNeg = i.isNeg;
    }
    return s;
  }

  function c(i, n) {
    var s;
    if (i.isNeg != n.isNeg) n.isNeg = !n.isNeg, s = h(i, n), n.isNeg = !n.isNeg;else {
      s = new t();
      var e, r;
      r = 0;

      for (g = 0; g < i.digits.length; ++g) {
        e = i.digits[g] - n.digits[g] + r, s.digits[g] = 65535 & e, s.digits[g] < 0 && (s.digits[g] += H), r = 0 - Number(e < 0);
      }

      if (-1 == r) {
        r = 0;

        for (var g = 0; g < i.digits.length; ++g) {
          e = 0 - s.digits[g] + r, s.digits[g] = 65535 & e, s.digits[g] < 0 && (s.digits[g] += H), r = 0 - Number(e < 0);
        }

        s.isNeg = !i.isNeg;
      } else s.isNeg = i.isNeg;
    }
    return s;
  }

  function l(i) {
    for (var t = i.digits.length - 1; t > 0 && 0 == i.digits[t];) {
      --t;
    }

    return t;
  }

  function N(i) {
    var t,
        n = l(i),
        s = i.digits[n],
        e = (n + 1) * G;

    for (t = e; t > e - G && 0 == (32768 & s); --t) {
      s <<= 1;
    }

    return t;
  }

  function v(i, n) {
    for (var s, e, r, g = new t(), d = l(i), o = l(n), u = 0; u <= o; ++u) {
      s = 0, r = u;

      for (var a = 0; a <= d; ++a, ++r) {
        e = g.digits[r] + i.digits[a] * n.digits[u] + s, g.digits[r] = e & L, s = e >>> q;
      }

      g.digits[u + d + 1] = s;
    }

    return g.isNeg = i.isNeg != n.isNeg, g;
  }

  function m(i, n) {
    var s,
        e,
        r,
        g = new t();
    s = l(i), e = 0;

    for (var d = 0; d <= s; ++d) {
      r = g.digits[d] + i.digits[d] * n + e, g.digits[d] = r & L, e = r >>> q;
    }

    return g.digits[1 + s] = e, g;
  }

  function w(i, t, n, s, e) {
    for (var r = Math.min(t + e, i.length), g = t, d = s; g < r; ++g, ++d) {
      n[d] = i[g];
    }
  }

  function A(i, n) {
    var s = Math.floor(n / G),
        e = new t();
    w(i.digits, 0, e.digits, s, e.digits.length - s);

    for (var r = n % G, g = G - r, d = e.digits.length - 1, o = d - 1; d > 0; --d, --o) {
      e.digits[d] = e.digits[d] << r & L | (e.digits[o] & T[r]) >>> g;
    }

    return e.digits[0] = e.digits[d] << r & L, e.isNeg = i.isNeg, e;
  }

  function C(i, n) {
    var s = Math.floor(n / G),
        e = new t();
    w(i.digits, s, e.digits, 0, i.digits.length - s);

    for (var r = n % G, g = G - r, d = 0, o = d + 1; d < e.digits.length - 1; ++d, ++o) {
      e.digits[d] = e.digits[d] >>> r | (e.digits[o] & U[r]) << g;
    }

    return e.digits[e.digits.length - 1] >>>= r, e.isNeg = i.isNeg, e;
  }

  function E(i, n) {
    var s = new t();
    return w(i.digits, 0, s.digits, n, s.digits.length - n), s;
  }

  function k(i, n) {
    var s = new t();
    return w(i.digits, n, s.digits, 0, s.digits.length - n), s;
  }

  function B(i, n) {
    var s = new t();
    return w(i.digits, 0, s.digits, 0, n), s;
  }

  function y(i, t) {
    if (i.isNeg != t.isNeg) return 1 - 2 * Number(i.isNeg);

    for (var n = i.digits.length - 1; n >= 0; --n) {
      if (i.digits[n] != t.digits[n]) return i.isNeg ? 1 - 2 * Number(i.digits[n] > t.digits[n]) : 1 - 2 * Number(i.digits[n] < t.digits[n]);
    }

    return 0;
  }

  function D(i, s) {
    var e,
        r,
        g = N(i),
        d = N(s),
        o = s.isNeg;
    if (g < d) return i.isNeg ? ((e = n(j)).isNeg = !s.isNeg, i.isNeg = !1, s.isNeg = !1, r = c(s, i), i.isNeg = !0, s.isNeg = o) : (e = new t(), r = n(i)), new Array(e, r);
    e = new t(), r = i;

    for (var u = Math.ceil(d / G) - 1, a = 0; s.digits[u] < I;) {
      s = A(s, 1), ++a, ++d, u = Math.ceil(d / G) - 1;
    }

    r = A(r, a), g += a;

    for (var f = Math.ceil(g / G) - 1, v = E(s, f - u); -1 != y(r, v);) {
      ++e.digits[f - u], r = c(r, v);
    }

    for (var w = f; w > u; --w) {
      var k = w >= r.digits.length ? 0 : r.digits[w],
          B = w - 1 >= r.digits.length ? 0 : r.digits[w - 1],
          D = w - 2 >= r.digits.length ? 0 : r.digits[w - 2],
          F = u >= s.digits.length ? 0 : s.digits[u],
          M = u - 1 >= s.digits.length ? 0 : s.digits[u - 1];
      e.digits[w - u - 1] = k == F ? L : Math.floor((k * H + B) / F);

      for (var b = e.digits[w - u - 1] * (F * H + M), p = k * J + (B * H + D); b > p;) {
        b = --e.digits[w - u - 1] * (F * H | M), p = k * H * H + (B * H + D);
      }

      (r = c(r, m(v = E(s, w - u - 1), e.digits[w - u - 1]))).isNeg && (r = h(r, v), --e.digits[w - u - 1]);
    }

    return r = C(r, a), e.isNeg = i.isNeg != o, i.isNeg && (e = o ? h(e, j) : c(e, j), r = c(s = C(s, a), r)), 0 == r.digits[0] && 0 == l(r) && (r.isNeg = !1), new Array(e, r);
  }

  function F(i, t) {
    return D(i, t)[0];
  }

  function M(i) {
    this.modulus = n(i), this.k = l(this.modulus) + 1;
    var s = new t();
    s.digits[2 * this.k] = 1, this.mu = F(s, this.modulus), this.bkplus1 = new t(), this.bkplus1.digits[this.k + 1] = 1, this.modulo = b, this.multiplyMod = p, this.powMod = S;
  }

  function b(i) {
    var t = k(v(k(i, this.k - 1), this.mu), this.k + 1),
        n = c(B(i, this.k + 1), B(v(t, this.modulus), this.k + 1));
    n.isNeg && (n = h(n, this.bkplus1));

    for (var s = y(n, this.modulus) >= 0; s;) {
      s = y(n = c(n, this.modulus), this.modulus) >= 0;
    }

    return n;
  }

  function p(i, t) {
    var n = v(i, t);
    return this.modulo(n);
  }

  function S(i, n) {
    var s = new t();
    s.digits[0] = 1;

    for (var e = i, r = n;;) {
      if (0 != (1 & r.digits[0]) && (s = this.multiplyMod(s, e)), 0 == (r = C(r, 1)).digits[0] && 0 == l(r)) break;
      e = this.multiplyMod(e, e);
    }

    return s;
  }

  function z(i, t, n, s) {
    this.e = u(i), this.d = u(t), this.m = u(n), this.chunkSize = "number" != typeof s ? 2 * l(this.m) : s / 8, this.radix = 16, this.barrett = new M(this.m);
  }

  function P(i, n, s, r) {
    var d,
        o,
        u,
        f,
        h,
        c,
        l,
        N,
        v,
        m = new Array(),
        w = n.length,
        A = "";

    for (f = "string" == typeof s ? s == V.NoPadding ? 1 : s == V.PKCS1Padding ? 2 : 0 : 0, h = "string" == typeof r && r == V.RawEncoding ? 1 : 0, 1 == f ? w > i.chunkSize && (w = i.chunkSize) : 2 == f && w > i.chunkSize - 11 && (w = i.chunkSize - 11), d = 0, o = 2 == f ? w - 1 : i.chunkSize - 1; d < w;) {
      f ? m[o] = n.charCodeAt(d) : m[d] = n.charCodeAt(d), d++, o--;
    }

    for (1 == f && (d = 0), o = i.chunkSize - w % i.chunkSize; o > 0;) {
      if (2 == f) {
        for (c = Math.floor(256 * Math.random()); !c;) {
          c = Math.floor(256 * Math.random());
        }

        m[d] = c;
      } else m[d] = 0;

      d++, o--;
    }

    for (2 == f && (m[w] = 0, m[i.chunkSize - 2] = 2, m[i.chunkSize - 1] = 0), l = m.length, d = 0; d < l; d += i.chunkSize) {
      for (N = new t(), o = 0, u = d; u < d + i.chunkSize; ++o) {
        N.digits[o] = m[u++], N.digits[o] += m[u++] << 8;
      }

      v = i.barrett.powMod(N, i.e), A += 1 == h ? a(v) : 16 == i.radix ? g(v) : e(v, i.radix);
    }

    return A;
  }

  var x,
      R,
      K,
      j,
      q = 16,
      G = q,
      H = 65536,
      I = H >>> 1,
      J = H * H,
      L = H - 1;
  i(130);
  !function (i) {
    var n = new t();
    n.isNeg = i < 0, i = Math.abs(i);

    for (var s = 0; i > 0;) {
      n.digits[s++] = i & L, i >>= q;
    }
  }(1e15);
  var O = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"),
      Q = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"),
      T = new Array(0, 32768, 49152, 57344, 61440, 63488, 64512, 65024, 65280, 65408, 65472, 65504, 65520, 65528, 65532, 65534, 65535),
      U = new Array(0, 1, 3, 7, 15, 31, 63, 127, 255, 511, 1023, 2047, 4095, 8191, 16383, 32767, 65535),
      V = {};
  return V.NoPadding = "NoPadding", V.PKCS1Padding = "PKCS1Padding", V.RawEncoding = "RawEncoding", V.NumericEncoding = "NumericEncoding", {
    encrypt: function encrypt(t, n, s) {
      return i(130), s = s || "NoPadding", P(new z("10001", "", n = n || "B1B1EC76A1BBDBF0D18E8CD9A87E53FA3881E2F004C67C9DDA2CA677DBEFA3D61DF8463FE12D84FF4B4699E02C9D41CAB917F5A8FB9E35580C4BDF97763A0420A476295D763EE10174E6F9EBF7DF8A77BA5B20CDA4EE705DEF5BBA3C88567B9656E52C9CD5CD95CA735FF2D25F762B133273EEEB7B4F3EA8B6DA29040F3B67CD", 1024), t, s);
    }
  };
});